// src/components/Quotation/QuotationStatusModal.jsx
import React, { useState } from "react";
import { changeStatus } from "../../api/quotationApi";
import QuotationStatusBadge from "./QuotationStatusBadge";

const ALLOWED_TRANSITIONS = {
  DRAFT:    ["SENT", "REJECTED"],
  SENT:     ["APPROVED", "REJECTED"],
  APPROVED: [],
  REJECTED: [],
  INVOICED: [],
};

const QuotationStatusModal = ({ quotation, onClose, onSuccess }) => {
  const allowed = ALLOWED_TRANSITIONS[quotation.status] || [];
  const [selected, setSelected] = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const handleSubmit = async () => {
    if (!selected) return setError("Please select a new status.");
    setLoading(true);
    setError("");
    try {
      const res = await changeStatus(quotation.id, selected);
      if (res.ok) {
        onSuccess();
        onClose();
      } else {
        const err = await res.json();
        setError(err.message || `Error ${res.status}`);
      }
    } catch (e) {
      setError("Network error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={modalHeader}>
          <span style={{ fontSize: 15, fontWeight: 600 }}>Change Quotation Status</span>
          <button onClick={onClose} style={closeBtn}>✕</button>
        </div>
        <div style={{ padding: "20px" }}>
          <div style={{ marginBottom: 16 }}>
            <span style={{ fontSize: 13, color: "#6B7280", marginRight: 8 }}>Current status:</span>
            <QuotationStatusBadge status={quotation.status} />
          </div>

          {allowed.length === 0 ? (
            <div style={{ fontSize: 13, color: "#6B7280", padding: "12px", background: "#F9FAFB", borderRadius: 8 }}>
              {quotation.status === "APPROVED"
                ? "This quotation is approved. Use the 'Generate Invoice' button to create an invoice."
                : "No further status changes are allowed for this quotation."}
            </div>
          ) : (
            <>
              <label style={labelStyle}>Select new status *</label>
              <select
                style={selectStyle}
                value={selected}
                onChange={e => setSelected(e.target.value)}
              >
                <option value="">Choose status...</option>
                {allowed.map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </>
          )}

          {error && <div style={errorBox}>{error}</div>}
        </div>

        <div style={modalFooter}>
          <button onClick={onClose} style={cancelBtn}>Cancel</button>
          {allowed.length > 0 && (
            <button onClick={handleSubmit} disabled={loading || !selected} style={submitBtn}>
              {loading ? "Updating..." : "Update Status"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const overlay     = { position:"fixed",inset:0,background:"rgba(0,0,0,0.45)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000 };
const modal       = { background:"#fff",borderRadius:14,width:"100%",maxWidth:440,boxShadow:"0 8px 32px rgba(0,0,0,0.12)" };
const modalHeader = { display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 20px",borderBottom:"0.5px solid #E5E7EB" };
const closeBtn    = { background:"none",border:"none",cursor:"pointer",fontSize:16,color:"#6B7280" };
const modalFooter = { display:"flex",justifyContent:"flex-end",gap:10,padding:"14px 20px",borderTop:"0.5px solid #E5E7EB" };
const labelStyle  = { display:"block",fontSize:12.5,fontWeight:500,color:"#374151",marginBottom:6 };
const selectStyle = { width:"100%",padding:"9px 12px",borderRadius:8,border:"0.5px solid #D1D5DB",fontSize:13,outline:"none",boxSizing:"border-box",cursor:"pointer" };
const errorBox    = { fontSize:12.5,color:"#EF4444",background:"#FEF2F2",border:"0.5px solid #FECACA",borderRadius:8,padding:"8px 12px",marginTop:10 };
const cancelBtn   = { fontSize:13,padding:"7px 16px",borderRadius:8,background:"#F9FAFB",border:"0.5px solid #D1D5DB",color:"#374151",cursor:"pointer" };
const submitBtn   = { fontSize:13,fontWeight:600,padding:"7px 20px",borderRadius:8,background:"#1A56DB",color:"#fff",border:"none",cursor:"pointer" };

export default QuotationStatusModal;
